import ScreenWrapper from "crqlar-react-common/dist/components/ScreenWrapper";
import {Box, Stack, Typography} from "@mui/material";
import {useLocalize} from "crqlar-react-common/dist/utils/text.util";

const Unauthorized = () => {
    const {t} = useLocalize()

    return (
        <ScreenWrapper>

            <Stack
                marginTop={10}
                direction={'column'}
                gap={10}
            >
                <Box
                    className="unauthorized"
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}
                >
                    <Typography variant="h1">
                        {t('Unauthorized')}
                    </Typography>
                </Box>

                <Box>
                    <Typography
                        variant="h3"
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            textAlign: 'center',
                            opacity: 0.7,
                            fontSize: '1.2rem',
                            lineHeight: '1.5rem',
                            fontWeight: 400,
                            color: 'text.secondary',
                            maxWidth: '500px',
                            margin: '0 auto',
                            marginBottom: '20px'
                        }}
                    >
                        {t('You do not have permission to access this page. Please contact your administrator.')}
                    </Typography>
                </Box>
            </Stack>

        </ScreenWrapper>
    )
}

export default Unauthorized
